import React, { useState, useEffect, useMemo, useRef, useContext } from 'react';
import { StateContext } from '../stateContext';
import apiClient from '../utils/apiClient'; // Assume this is configured to work with your backend API
import {trackTextBlocksAcrossFrames} from '../utils/trackingUtils'
import { useLocation, useParams, useNavigate } from 'react-router-dom'; // Import useParams
import { useUser } from '../utils/UserProvider';
import { formatSeconds } from '../utils/timeUtils';
import axios from 'axios'
import storage from "../utils/local_storage"


function ViewNumericalUpload({results, uploadID, urls}) {
  const {setToastData} = useContext(StateContext);
  const [imageLoading, setImageLoading] = useState(true);
  const [textBlocks, setTextBlocks] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [imageOffsets, setImageOffsets] = useState({ horizontalOffset: 0, verticalOffset: 0 });
  const imageRef = useRef(null);
  const [scaleFactor, setScaleFactor] = useState({ x: 1, y: 1 });
  const [selectedBlocks, setSelectedBlocks] = useState(new Map());
  const [trackedBlocks, setTrackedBlocks] = useState(new Set()); // Track clicked boxes
  const [selectedFrame, setSelectedFrame] = useState(1); // Track clicked boxes
  const [selectedFrameValue, setSelectedFrameValue] = useState(1); // Track clicked boxes
  const [trackingValue, setTrackingValue] = useState(85);
  const [trackingThreshold, setTrackingThreshold] = useState(trackingValue);
  const [disappearanceValue, setDisappearanceValue] = useState(1);
  const [disappearanceThreshold, setDisappearanceThreshold] = useState(disappearanceValue);
  const [sizeValue, setSizeValue] = useState(0);
  const [sizeThreshold, setSizeThreshold] = useState(sizeValue);
  const [editingBlockId, setEditingBlockId] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState([])
  const [confidenceValue, setConfidenceValue] = useState(50)
  const [confidenceThreshold, setConfidenceThreshold] = useState(50)


  const [ocrResults, setOcrResults] = useState(null);
  const [maxValues, setMaxValues] = useState(null);
  const { uploadIDParam } = useParams();
  if (uploadIDParam) {
    uploadID = uploadIDParam;
  }
  const location = useLocation();
  const path = location.pathname;
  const { demoData } = location.state || {};
  const [isOpen, setIsOpen] = useState(path.includes('/demo') || !storage.getItem("ViewedHowTo"));
  const [isNoResultsDialogOpen, setIsNoResultsDialogOpen] = useState(false);
  // console.log("ViewedHowTo", storage.getItem("ViewedHowTo"))
  const { user } = useUser();
  const [exportOptions, setExportOptions] = useState({values:true, locations:false})
  const navigate = useNavigate();

  useEffect(() => {
    if (imageRef.current) {
      const { offsetWidth: width, offsetHeight: height } = imageRef.current;
      setImageSize({ width, height });
    }
  }, [imageURL]);

  useEffect(() => {
    if (!textBlocks && (path.includes('/demo') || user) && !results) {
      handleUploadOpen(uploadIDParam);
    }
  }, [user, uploadIDParam, path, textBlocks, results]);

      useEffect(() => {
    if (results) {
            setOcrResults(results.ocrResults);
            setMaxValues(results.maxValues);
            setSelectedBlocks(new Map());
            setTextBlocks(trackTextBlocksAcrossFrames(results.ocrResults, trackingThreshold, disappearanceThreshold, confidenceThreshold, results.maxValues));
            setImageURL(urls);
          }
  }, []);

  const handleUploadOpen = async (uploadIDParam) => {
    try {
        console.log("fetching upload data");

        let response;
        let theseOcrResults
        if (demoData?.results) {
            response = { data: demoData };
        } else {
            if (path.includes('/demo')) uploadIDParam = "demo";
            response = await apiClient.get(`/getUploadDetailsOld/${uploadIDParam}`, {
              params: { mode: 'numerical' },
            });
}

        const { uploadData, results, urls } = response.data;
        console.log({uploadData})
        if (results.results?.length === 0) setIsNoResultsDialogOpen(true)

        setImageURL(urls); // Set the signed URL for the image

        if (results.resultsUrl) {
            // Results are provided as a signed URL to a file in storage
            console.log("resultsURL: ", results.resultsUrl)
            const resultsResponse = await axios.get(results.resultsUrl);
            const resultsData = resultsResponse.data; // the actual data you're interested in
            console.log({resultsData})
            setOcrResults(resultsData);
            setMaxValues(resultsData.maxValues);
          setTextBlocks(trackTextBlocksAcrossFrames(resultsData, trackingThreshold, disappearanceThreshold, confidenceThreshold, resultsData.maxValues));

        } else {
            // Results are provided directly from the backend
            console.log(results.maxValues)
            setOcrResults(results.results);
            setMaxValues(results.maxValues);
            setTextBlocks(trackTextBlocksAcrossFrames(results.results, trackingThreshold, disappearanceThreshold, confidenceThreshold, results.maxValues));
        }

        setSelectedBlocks(new Map());
    } catch (error) {
        console.error('Error fetching upload details:', error);
        setToastData({text:"No results found.", show:true})
    }
};


// useEffect(() => {
//     const handleResize = () => {
//         if (imageRef.current) {
//             const { naturalWidth, naturalHeight } = imageRef.current;
//             const { width, height } = imageRef.current.getBoundingClientRect(); // Displayed dimensions
//             setScaleFactor({
//                 x: width / naturalWidth,
//                 y: height / naturalHeight
//             });

//             // Adjust for both axes
//             const container = imageRef.current.parentElement;
//             const containerAspectRatio = container.offsetWidth / container.offsetHeight;
//             const imageAspectRatio = naturalWidth / naturalHeight;
//             let horizontalOffset = 0, verticalOffset = 0;

//             if (containerAspectRatio > imageAspectRatio) {
//                 // Container is wider than image: adjust horizontally
//                 horizontalOffset = (container.offsetWidth - (naturalWidth * scaleFactor.x)) / 2;
//             } else {
//                 // Container is taller than image: adjust vertically
//                 verticalOffset = (container.offsetHeight - (naturalHeight * scaleFactor.y)) / 2;
//             }

//             // Use these offsets when positioning your text blocks
//             setImageOffsets({horizontalOffset, verticalOffset})
//         }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
// }, [imageURL, selectedFrame, trackedBlocks, trackingThreshold, sizeThreshold, disappearanceThreshold]);

// const handleBoxClick = (blockID) => {
//   console.log({ blockID });
//   const updatedSelectedBlocks = new Set(selectedBlocks);
//   if (updatedSelectedBlocks.has(blockID)) {
//     updatedSelectedBlocks.delete(blockID);
//   } else {
//     updatedSelectedBlocks.add(blockID);
//     // console.log(blockID, trackedBlocks[selectedFrame - 1]);
//     console.log({updatedSelectedBlocks})
//   }
//   setSelectedBlocks(new Set(updatedSelectedBlocks)); // Ensure a new object reference to trigger re-render
// };

const addSeries = (blockID) => {
  setSelectedBlocks(prevSelectedBlocks => {
    const updatedSelectedBlocks = new Map(prevSelectedBlocks);
    const uniqueID = Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number

    // Find the block in the current frame to get its text
    const currentFrameBlocks = trackedBlocks[selectedFrame - 1] || [];
    const block = currentFrameBlocks.find(b => b.id === blockID);
    const blockText = block ? block.text : '';

    // Function to truncate the text
    const getTruncatedText = (text, maxWords) => {
      let truncated = text.split(/\s+/).slice(0, maxWords).join(' ');
      if (truncated.length > 25) return getTruncatedText(text, maxWords - 1);
      return truncated.length > 15 ? truncated.slice(0, 15)+" Block" : truncated + " Block";
    };

    // Check if the block is already in selectedBlocks and if it's locked
    if (updatedSelectedBlocks.has(blockID)) {
      const blockData = updatedSelectedBlocks.get(blockID);
      if (blockData.locked) {
        console.log("Block is locked, cannot add again.");
        return prevSelectedBlocks;
      }
    } else {
      updatedSelectedBlocks.set(blockID, {
        locked: false,
        settings: { seriesName: getTruncatedText(blockText, 3) },
        originalId: blockID,
        uniqueID
      });
    }

    return updatedSelectedBlocks;
  });
  setEditingBlockId(blockID);
};

const removeSeries = (blockID) => {
  setSelectedBlocks(prevSelectedBlocks => {
    const updatedSelectedBlocks = new Map(prevSelectedBlocks);
    const block = updatedSelectedBlocks.get(blockID);
    if (block && block.locked) {
        setToastData({text:"Unlock block series before deleting.", show:true})
      return prevSelectedBlocks;
    }
    updatedSelectedBlocks.delete(blockID);
    if (editingBlockId === blockID) {
      setEditingBlockId(null);
    }
    return updatedSelectedBlocks;
  });
};

const removeUnlockedSeries = () => {
  setEditingBlockId(null)
  setSelectedBlocks(prevSelectedBlocks => {
    const updatedSelectedBlocks = new Map(prevSelectedBlocks);
    for (let [key, value] of updatedSelectedBlocks) {
      if (!value.locked) {
        updatedSelectedBlocks.delete(key);
      }
    }
    return updatedSelectedBlocks;
  });
};

const toggleLock = (blockID) => {
  setSelectedBlocks(prevSelectedBlocks => {
    const updatedSelectedBlocks = new Map(prevSelectedBlocks);
    const blockData = updatedSelectedBlocks.get(blockID);

    if (blockData) {
      // Check if blockID or its originalId is in trackedBlocks
      const isInTrackedBlocks = trackedBlocks.some(frame => frame.find(block => block.id === blockID || block.id === blockData.originalId));

      if (isInTrackedBlocks) {
        if (!blockData.locked) {
          // Locking the block: Assign a unique ID and store the original ID
          // const uniqueID = Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number
          updatedSelectedBlocks.delete(blockID); // Remove the block with the old ID
          updatedSelectedBlocks.set(blockData.uniqueID, { ...blockData, locked: true, originalId: blockID, total: calculateBlockTotal(blockID) });
          setEditingBlockId(null)
        } else {
          // Unlocking the block: Revert to the original ID if it's not in use
          const originalId = blockData.originalId;
          updatedSelectedBlocks.delete(blockID); // Remove the block with the unique ID
          if (!updatedSelectedBlocks.has(originalId)) {
            updatedSelectedBlocks.set(originalId, { ...blockData, locked: false });
          } else {
            // If the original ID is in use, keep the unique ID but unlock the block
            updatedSelectedBlocks.set(blockID, { ...blockData, locked: false });
          }
        }
      } else {
        // Remove block series if its ID is no longer found in trackedBlocks
        updatedSelectedBlocks.delete(blockID);
        if (editingBlockId === blockID) {
          setEditingBlockId(null);
        }
      }
    }

    return updatedSelectedBlocks;
  });
};



// Function to calculate the total count for a block
// This should be defined to calculate the total based on your data structure
const calculateBlockTotal = (blockID) => {
    const total = trackedBlocks.reduce((count, frame) => {
        return count + (frame.some(block => block?.id === blockID) ? 1 : 0);
    }, 0);

    return total;
};

function sortSelectedBlocksByVerticalPosition(selectedBlocks, selectedSeries) {
    // Convert Map to Array for sorting
    let blockArray = Array.from(selectedBlocks.entries()).map(([key, value]) => ({
        id: key,
        block: value
    }));
    console.log({blockArray})
    // Sort based on average vertical position
    blockArray.sort((a, b) => {
        const aFrames = selectedSeries.get(a.id);
        const bFrames = selectedSeries.get(b.id);

        const aAverage = getAverageVerticalPosition(aFrames);
        const bAverage = getAverageVerticalPosition(bFrames);

        return aAverage - bAverage;
    });
    console.log({blockArray})

    // Optionally, convert back to a Map if needed
    const sortedMap = new Map(blockArray.map(item => [item.id, item.block]));

    return sortedMap; // or return blockArray if you prefer to work with array
}



function getAverageVerticalPosition(frames) {
    if (!frames || frames.length === 0) return Infinity; // Handle no frames case

    let totalVerticalCenter = 0;
    let validFrames = 0;

    frames.forEach(frame => {
        if (frame && frame.vertices) {
            // Calculate the vertical center from vertices
            const verticalCenter = frame.vertices.reduce((acc, vertex) => acc + vertex.y, 0) / frame.vertices.length;
            totalVerticalCenter += verticalCenter;
            validFrames++;
        }
    });
    return validFrames > 0 ? totalVerticalCenter / validFrames : Infinity; // Avoid division by zero
}




function exportToCSV() {
    const headers = ["Frame", "Time"];
    let includeOriginalText = false;

    // Check all blocks across all frames to see if any have 'originalText'
    selectedBlocks.forEach((blockData, blockId) => {
        const seriesFrames = selectedSeries.get(blockId);
        if (seriesFrames) {
            for (const frame of seriesFrames) {
                if (frame?.originalText) {
                    includeOriginalText = true;
                    break;
                }
            }
        }
    });
    console.log({includeOriginalText})
    // if (true || uploadData.mediaContent === "captions") {
    const sortedSelectedBlocks = sortSelectedBlocksByVerticalPosition(selectedBlocks, selectedSeries);
    // }

    sortedSelectedBlocks.forEach((blockData, blockId) => {
      headers.push(blockData.settings.seriesName ? `"${blockData.settings.seriesName}${includeOriginalText ? " Translated":""}"` : `"Block ${blockId}${includeOriginalText ? " translated":""}"`);
        if (includeOriginalText) headers.push(blockData.settings.seriesName ? `"${blockData.settings.seriesName}${includeOriginalText ? " Original":""}"` : `"Block ${blockId} Original"`);
    });

    const rows = trackedBlocks.map((_, frameIndex) => {
        const row = [frameIndex + 1, formatSeconds(Number(imageURL[frameIndex].split('/').pop().split('.')[0])/1000, "min:sec") || "0:00"];

        sortedSelectedBlocks.forEach((blockData, blockId) => {
            const seriesFrames = selectedSeries.get(blockId); 
            const block = seriesFrames ? seriesFrames[frameIndex] : null;
            const modifiedText = block ? applyBlockSettings(block.text, blockData.settings) : "";
            row.push(`"${modifiedText}"`);
            // includeOriginalText && block?.originalText && row.push(`"${block?.originalText}"`)
            if (includeOriginalText) block?.originalText ? row.push(`"${block?.originalText}"`) : row.push("")

          });

        return row;
    });

    let csvContent = [headers].concat(rows).map(e => e.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'export.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


function applyBlockSettings(text, settings) {
    if (!text || !settings) return text;

    let modifiedText = text;

    // Remove a list of words, separated by non-alphabetical characters
    if (settings.wordsToRemove) {
        const wordsToRemoveArray = settings.wordsToRemove.split(/\W+/);
        wordsToRemoveArray.forEach(word => {
            if (word) {
                modifiedText = modifiedText.replace(new RegExp(`\\b${word}\\b`, 'gi'), '');
            }
        });
    }

    // Remove specific characters
    if (settings.charactersToRemove) {
        modifiedText = modifiedText.replace(new RegExp(`[${settings.charactersToRemove}]`, 'g'), '');
    }

    // Split and keep a specific part, only if keepSplitItem has a meaningful value
    if (settings.characterToSplit && settings.keepSplitItem > 0) {
        const parts = modifiedText.split(settings.characterToSplit);
        const partIndex = settings.keepSplitItem - 1;
        modifiedText = parts.length > partIndex ? parts[partIndex] : modifiedText;
    }

    // Numbers only option
    if (settings.numbersOnly) {
        // This regex matches non-numeric characters except periods that are part of decimal numbers
        modifiedText = modifiedText.replace(/(?<!\d)\.|(?<=\d\.)\D|\D(?!\d)/g, '');
    }

    return modifiedText;
}




// Usage example: exportToCSV(selectedBlocks, trackedBlocks, ocrResults, formatSeconds);


// const updateBlockSettings = (blockID, newSettings) => {
//   setSelectedBlocks(prevSelectedBlocks => {
//     const updatedSelectedBlocks = new Map(prevSelectedBlocks);
//     if (updatedSelectedBlocks.has(blockID)) {
//       const blockData = updatedSelectedBlocks.get(blockID);
//       updatedSelectedBlocks.set(blockID, { ...blockData, settings: { ...blockData.settings, ...newSettings } });
//     }
//     console.log({updatedSelectedBlocks})
//     return updatedSelectedBlocks;
//   });
// };

useEffect(() => {
  const updateSelectedSeries = () => {
    const newSelectedSeries = new Map();

    selectedBlocks.forEach((blockData, blockId) => {
      if (blockData.locked) {
        // For locked blocks, use the existing series if available
        const existingSeries = selectedSeries.get(blockId);
        if (existingSeries) {
          newSelectedSeries.set(blockId, existingSeries);
        } else {
          // If there's no existing series (e.g., for newly locked blocks), fetch it from trackedBlocks
          const seriesFrames = trackedBlocks.map(frame =>
            frame.find(block => block.id === blockData.originalId || block.id === blockId)
          );
          newSelectedSeries.set(blockId, seriesFrames);
        }
      } else {
        // For unlocked blocks, always fetch the latest series from trackedBlocks
        const seriesFrames = trackedBlocks.map(frame => 
          frame.find(block => block.id === blockData.originalId || block.id === blockId)
        );
        newSelectedSeries.set(blockId, seriesFrames);
      }
    });

    setSelectedSeries(newSelectedSeries);
  };

  updateSelectedSeries();
}, [trackedBlocks, selectedBlocks]);


function areMapsEqual(map1, map2) {
  if (map1.size !== map2.size) return false;
  for (const [key, val] of map1) {
    if (!map2.has(key) || map2.get(key) !== val) return false;
  }
  return true;
}

  useEffect(() => {
  if (ocrResults) {
      // setSelectedBlocks(new Set())
      const trackedBlocks = trackTextBlocksAcrossFrames(ocrResults, trackingThreshold, disappearanceThreshold, sizeThreshold, confidenceThreshold, maxValues);
      // console.log({trackedBlocks})
      setTrackedBlocks(trackedBlocks)
      setSelectedBlocks((prevSelectedBlocks) => {
        
        const updatedSelectedBlocks = new Map(prevSelectedBlocks);
        
        // Get all block IDs in trackedBlocks for easy lookup
        const trackedBlockIDs = new Set(trackedBlocks.flatMap(frame => frame.map(block => block.id)));
        
        // Remove any selected blocks that are not found in trackedBlocks
        for (let [blockId, blockData] of updatedSelectedBlocks) {
          if (!trackedBlockIDs.has(blockId) && !blockData.locked) {
            updatedSelectedBlocks.delete(blockId);
            }
          }
          
          return updatedSelectedBlocks;
        });
      }

    
  }, [ocrResults, trackingThreshold, disappearanceThreshold, sizeThreshold, confidenceThreshold]);

  // Handlers for threshold changes
  const handleTrackingValueChange = (e) => {
    setTrackingValue(Number(e.target.value));
  };

  const handleSetTrackingValue = (e) => {
    setTrackingThreshold(Number(e.target.value));
    removeUnlockedSeries()

  };

  const handleDisappearanceValueChange = (e) => {
    setDisappearanceValue(Number(e.target.value));
  };

  const handleSetDisappearanceValue = (e) => {
    setDisappearanceThreshold(Number(e.target.value));
    removeUnlockedSeries()

  };

  const handleSizeValueChange = (e) => {
    setSizeValue(Number(e.target.value));
  };

  const handleSetSizeValue = (e) => {
    setSizeThreshold(Number(e.target.value));
    removeUnlockedSeries()
  };
  
  const handleConfidenceValueChange = (e) => {
    setConfidenceValue(Number(e.target.value));
  };

  const handleSetConfidenceValue = (e) => {
    setConfidenceThreshold(Number(e.target.value));
    removeUnlockedSeries()
  };

  const handleFrameSelect = (e) => {
    setSelectedFrame(Number(e.target.value));
  };

  const handleFrameValueChange = (e) => {
    setSelectedFrameValue(Number(e.target.value));
    if (urls?.length < 25) {
      setSelectedFrame(Number(e.target.value));
    }
  };

  const reverseFrame = () => {
    const frameNumber = selectedFrame > 1 ? selectedFrame - 1 : selectedFrame
    setSelectedFrame(frameNumber);
    setSelectedFrameValue(frameNumber)
  };

  const advanceFrame = () => {
    const frameNumber = selectedFrame < trackedBlocks.length ? selectedFrame + 1 : selectedFrame
    setSelectedFrame(frameNumber);
    setSelectedFrameValue(frameNumber)
  };

  const handleEditClick = (blockId) => {
  setEditingBlockId(editingBlockId === blockId ? null : blockId); // Toggle edit mode for this block
};

const handleFrameClick = (frameIndex) => {
    setSelectedFrameValue(frameIndex + 1);
    setSelectedFrame(frameIndex + 1);
};

const handleDialogClose = () => {
  if(!path.includes('/demo')) storage.setItem("ViewedHowTo", true)
  setIsOpen(false)
};

const handleImageLoad = () => {
    if (imageRef.current) {
        const { naturalWidth, naturalHeight } = imageRef.current;
        const { width, height } = imageRef.current.getBoundingClientRect();
        
        setScaleFactor({
            x: width / naturalWidth,
            y: height / naturalHeight
        });

        // Calculate and set offsets or any other dimension-dependent state
        // This might include setting the state for trackedBlocks or adjusting overlay positions
        const horizontalOffset = (imageRef.current.parentElement.offsetWidth - width) / 2;
        const verticalOffset = (imageRef.current.parentElement.offsetHeight - height) / 2;
        setImageOffsets({ horizontalOffset, verticalOffset });

        // If trackedBlocks or any other state needs to be initialized or updated based on the image size, do it here
        // For example:
        // setTrackedBlocks(trackTextBlocksAcrossFrames(ocrResults, trackingThreshold, disappearanceThreshold, sizeThreshold, maxValues));
    }
};

const updateBlockSetting = (blockId, settingKey, value) => {
    setSelectedBlocks(prevSelectedBlocks => {
        const updatedBlocks = new Map(prevSelectedBlocks);
        const blockData = updatedBlocks.get(blockId) || { settings: {} };
        blockData.settings = { ...blockData.settings, [settingKey]: value };
        updatedBlocks.set(blockId, blockData);
        return updatedBlocks;
    });
};

useEffect(() => {
    const imageElement = imageRef.current;

    if (!imageElement) return;

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            const { width, height } = entry.contentRect;
            const { naturalWidth, naturalHeight } = imageElement;

            setScaleFactor({
                x: width / naturalWidth,
                y: height / naturalHeight
            });

            const horizontalOffset = (entry.target.parentElement.offsetWidth - width) / 2;
            const verticalOffset = (entry.target.parentElement.offsetHeight - height) / 2;

            setImageOffsets({ horizontalOffset, verticalOffset });
        }
    });

    resizeObserver.observe(imageElement);

    return () => resizeObserver.disconnect();
}, [imageRef.current]); // Depend on imageRef.current to make sure the effect runs when the component mounts

  return (
    <div className="w-full mx-auto p-4 flex flex-col md:flex-row">
      {isOpen && (
        <div className="modal modal-open">
          <div className="modal-box">
            <h3 className="font-bold text-lg text-center">How to use the Numerical Tab</h3>
            <p className="py-4 text-center">Follow these steps to get data out of this video:</p>
            <p className="">
              <ol className="list-decimal pl-5">
                <li>Select a text block from the image.</li>
                <li>Adjust the sliders and settings in the <b>Selected Blocks</b> box until the <b>Blocks to Export</b> data looks correct.</li>
                <li>Click <b>Lock</b> on the block in <b>Selected Blocks</b> so that future settings adjustments do not affect that block.</li>
                <li>Click on the next text block of interest and repeat.</li>
                <li>When <b>Blocks to Export</b> looks good, scroll down and click <b>Export as CSV</b>.</li>
              </ol>
            </p>
            <div className="modal-action">
              <button className="btn" onClick={handleDialogClose}>Got it!</button>
            </div>
          </div>
        </div>
      )}
      {isNoResultsDialogOpen && 
      <div className="modal modal-open">
          <div className="modal-box">
            <h3 className="font-bold text-lg text-center">No Text Results Found</h3>
            <p className="text-center pb-2">
              Your media does not appear to contain any text.</p>
            <p className="text-center">
              If you believe this is an error, please let us know at textractifyapp@gmail.com
            </p>
            <div className="modal-action flex justify-between items-stretch w-full mx-auto">
              <button className="btn justify-start" onClick={() => navigate("/uploads")}>
                Back to Uploads
              </button>
              <button className="btn justify-end" onClick={()=>setIsNoResultsDialogOpen(false)}>
                Got it!
              </button>
            </div>
          </div>
        </div>}
      <div className="w-full md:w-1/2 h-full flex flex-col">
      <div className="relative w-full max-h-[50vh] overflow-hidden rounded-lg">
         {imageLoading && !imageURL ? (
        <div className="flex items-center justify-center h-[50vh]">
            <div className="bg-neutral p-4 rounded-lg flex flex-col items-center justify-center space-y-2">
              <span className="loading loading-spinner loading-lg text-white"></span>
              <p className="text-white text-lg">Loading Image</p>
              <p className="text-white text-sm">This could take a while for 100+ images</p>
            </div>
          </div>
      ) : (
        <img
          ref={imageRef}
          src={imageURL[selectedFrame - 1]}
          alt="Processed"
          onLoad={() => { handleImageLoad(); setImageLoading(false); }}
          style={{
            maxWidth: '100%',
            maxHeight: '50vh',
            objectFit: 'contain',
            display: 'block',
            margin: '0 auto'
          }}
        />
      )}
    {/* {textBlocks && textBlocks[selectedFrame-1]?.detections?.map((block, index) => { */}
        {trackedBlocks && imageRef?.current && trackedBlocks[selectedFrame-1]?.map((block, index) => {
        // Assuming scaleFactor.x and scaleFactor.y are already adjusted based on the resized image
        if (!block.vertices || block.vertices.length < 3) return null;

        const growSize = 7; // Amount by which to grow the box on each side
        const originalWidth = (block.vertices[1].x - block.vertices[0].x) * scaleFactor.x;
        const originalHeight = (block.vertices[2].y - block.vertices[0].y) * scaleFactor.y;
        const centerX = block.vertices[0].x * scaleFactor.x + originalWidth / 2;
        const centerY = block.vertices[0].y * scaleFactor.y + originalHeight / 2;

        // Calculate offsets
        const horizontalOffset = (imageRef.current.parentElement.offsetWidth - imageRef.current.offsetWidth) / 2;
        const verticalOffset = (imageRef.current.parentElement.offsetHeight - imageRef.current.offsetHeight) / 2;
        const isSelected = selectedBlocks.has(block.id);
        const isLocked = isSelected ? selectedBlocks.get(block.id).locked : false;

        const style = {
            left: `${centerX - (originalWidth / 2 + growSize) + horizontalOffset}px`,
            top: `${centerY - (originalHeight / 2 + growSize) + verticalOffset}px`,
            width: `${originalWidth + 2 * growSize}px`,
            height: `${originalHeight + 2 * growSize}px`,
        };

        // Tailwind classes for static properties
        const tailwindClasses = `absolute cursor-pointer pointer-events-auto rounded-md ${
            isSelected && !isLocked ? 'border-2 border-green-500' : 'border-2 border-red-500'
        }`;

        return (
            <div 
                key={index} 
                style={style} 
                className={`${tailwindClasses} hover:border-dashed`}
                title={`Block: ${block.id}`} 
                onClick={() => addSeries(block.id)}
            ></div>
        );
        })}
      </div>
      {/* <button className="btn btn-normal mx-auto" onClick={() => {setSelectedBlocks(new Map())}}>Clear Block Selections</button> */}
      {true && 
        <div className="flex flex-col p-2">
          <label className="tooltip tooltip-top" data-tip="Slide to scroll through the frames">Selected Frame: {selectedFrameValue}</label>
          <div className="flex flex-row items-center gap-2">
            <button className="btn btn-sm" onClick={reverseFrame}>Prev</button>
            <input type="range"  className="range range-success" min={1} max={textBlocks?.length} value={selectedFrameValue} onTouchEnd={handleFrameSelect} onMouseUp={handleFrameSelect} onChange={handleFrameValueChange}/>
            <button className="btn btn-sm" onClick={advanceFrame}>Next</button>
          </div>
        </div>}
        <div className="w-full  mx-auto justify-center items-center border-2 p-2 rounded-lg relative">
          <p className="text-center">Text Block Tracking Settings</p>
          <button className="btn btn-xs absolute top-2 right-2" onClick={()=>setIsOpen(true)}>?</button>
          <div className="flex flex-row items-center justify-center mx-auto">

            <p className="text-center text-xs">Use to tune how text blocks are linked between frames</p>
          </div>
          <label className="tooltip tooltip-top" data-tip="How similar blocks must be across frames to be considered the same block">Similarity Requirement: {trackingValue}%</label>
          <input type="range" className="range range-xs" min={75.0} max={100.0} step={0.5} value={trackingValue}
            onMouseUp={handleSetTrackingValue} // For mouse interaction
            onTouchEnd={handleSetTrackingValue} // For touch interaction
            onChange={handleTrackingValueChange} />

          <label className="tooltip tooltip-top" data-tip="The number of frames a text block can disappear and still be linked with a previous similar block">Allowable Disappearance: {disappearanceValue} frame{disappearanceValue===1 ? "" : "s"}</label>
          <input type="range"  className="range range-xs" min={0} max={10} value={disappearanceValue}
            onMouseUp={handleSetDisappearanceValue} // For mouse interaction
            onTouchEnd={handleSetDisappearanceValue} // For touch interaction
            onChange={handleDisappearanceValueChange} />

          <label className="tooltip tooltip-top" data-tip="Filters out blocks smaller than the current setting">Minimum block size: {sizeValue === 0 ? `All` : `${Math.round(sizeValue*100)}% of largest block`}</label>
          <input type="range"  className="range range-xs" min={0} max={1} step={.05} value={sizeValue}
            onMouseUp={handleSetSizeValue} // For mouse interaction
            onTouchEnd={handleSetSizeValue} // For touch interaction
            onChange={handleSizeValueChange} />
        {ocrResults?.length > 0 && ocrResults[0].detections[0]?.confidence && (
          <>
            <label className="tooltip tooltip-top" data-tip="The minimum required confidence in the detected text to be included in results.">Required Confidence: {`${Math.round(confidenceValue)}%`}</label>
            <input type="range"  className="range range-xs" min={50} max={100} value={confidenceValue}
              onMouseUp={handleSetConfidenceValue} // For mouse interaction
              onTouchEnd={handleSetConfidenceValue} // For touch interaction
              onChange={handleConfidenceValueChange} />
          </>
        )}
        </div>

      </div>
      <div className="w-full md:w-1/2 flex flex-col px-0 md:px-4 pt-4 md:pt-0">
        <div className="border-2 rounded-lg mb-4 max-h-[50vh] overflow-scroll">
        <p className="text-xl text-center font-bold">Selected Blocks</p>
        <div className="overflow-auto">
          <table className="table w-full">
            <thead>
              <tr className=" bg-base-300 uppercase text-xs whitespace-pre-wrap">
                <th className="py-2 px-2 text-center">Block Name</th>
                <th className="py-2 px-2 text-center">Frames with Block</th>
                <th className="py-2 px-2 text-center">Current Frame Text</th>
                <th className="py-2 px-2 text-center">Actions</th>
              </tr>
            </thead>
          <tbody className=" text-sm">
        {selectedBlocks && selectedBlocks.size > 0 ? 
          Array.from(selectedBlocks.entries())
          .sort((a, b) => {
            const [, blockDataA] = a;
            const [, blockDataB] = b;
            return blockDataA.uniqueID - blockDataB.uniqueID;
          })
          .map(([blockId, blockData], index) => {
          // Use the saved total if the block is locked, otherwise calculate it
          const blockTotal = blockData.locked && blockData.total !== undefined
            ? blockData.total
            : trackedBlocks.reduce((count, frame) => {
              return count + (frame.some(block => block?.id === blockId) ? 1 : 0);
            }, 0); // Initial count is 0

          // Find the block in the trackedBlocks for the selected frame that has this blockId
          // const block = trackedBlocks[selectedFrame - 1]?.find(block => block.id === blockId);
          let blockText = "N/A";
          let originalText = null;
          if (blockData.locked && blockData.text) {
            blockText = blockData.text;
            originalText = blockData?.originalText
          } else {
            const seriesFrames = selectedSeries.get(blockId); // Get the series for the block ID from selectedSeries
            const block = seriesFrames ? seriesFrames[selectedFrame - 1] : null; // Get the block for the current frameIndex
            blockText = block ? block.text : "N/A";
            originalText = block?.originalText
          }
          return (
            <>
              <tr key={index} className={`${editingBlockId !== blockId ? `${editingBlockId === null ? "hover:bg-base-300" : " blur-sm"}` : "bg-base-300"} `}>
                <td className="py-2 px-2 text-center whitespace-nowrap">
                  {blockData.settings.seriesName ? blockData.settings.seriesName : blockId}
                </td>
                <td className="py-2 px-2 text-center">
                  {blockTotal} ({blockTotal / trackedBlocks.length * 100 > 99 ? (blockTotal / trackedBlocks.length * 100).toFixed(2) : Math.round(blockTotal / trackedBlocks.length * 100)}%)
                </td>
                <td className="py-2 px-2 text-center" key={index}>{blockText}{originalText ? ` (${originalText})` : ""}</td>

                <td className="py-2 px-2 text-center flex flex-col gap-2 items-center justify-center">
                  <button className={`btn btn-sm ${editingBlockId === blockId ? "btn-success" : ""}`} onClick={() => handleEditClick(blockId)}>{editingBlockId === blockId ? "Close" : "Edit"}</button>
                  <button className={`btn btn-sm ${blockData.locked ? 'btn-success' : 'btn-primary'} ${blockData.locked ? "" : "tooltip tooltip-left"}`} data-tip="Lock to prevent tracking settings adjustments from affecting this series" onClick={() => toggleLock(blockId)}>
                    {blockData.locked ? 'Locked' : 'Lock'}
                  </button>
                  <button className="btn btn-sm btn-error" onClick={() => removeSeries(blockId)}>Remove</button>
                </td>
              </tr>
              {editingBlockId === blockId && (
                <tr key={index*10} className="bg-base-300">
                    <td colSpan="4" className="py-2 px-2 md:px-8 text-left">
                        <div className="flex flex-col border rounded-lg gap-4 py-4 items-center px-2">
                            <label className="flex items-center gap-2 px-2 w-full md:w-3/4">
                                <p className="w-full mx-auto">Block name:</p>
                                <input type="text" className="input input-bordered" value={selectedBlocks.get(editingBlockId)?.settings?.seriesName || ''} onChange={(e) => updateBlockSetting(editingBlockId, 'seriesName', e.target.value)} />
                            </label>
                            <label className="flex items-center gap-2 px-2 w-full md:w-3/4">
                                <p className="w-full mx-auto">Numbers only?</p>
                                <input type="checkbox" className="toggle" value={selectedBlocks.get(editingBlockId)?.settings?.numbersOnly} onChange={(e) => updateBlockSetting(editingBlockId, 'numbersOnly', e.target.checked)} />
                            </label>
                            <label className="flex items-center gap-2 px-2 w-full md:w-3/4">
                                <p className="w-full mx-auto">Words to remove:</p>
                                <input type="text" className="input input-bordered" className="input input-bordered" value={selectedBlocks.get(editingBlockId)?.settings?.wordsToRemove} onChange={(e) => updateBlockSetting(editingBlockId, 'wordsToRemove', e.target.value)}/>
                            </label>
                            <label className="flex items-center gap-2 px-2 w-full md:w-3/4">
                                <p className="w-full mx-auto">Characters to remove:</p>
                                <input type="text" className="input input-bordered" value={selectedBlocks.get(editingBlockId)?.settings?.charactersToRemove || ''} onChange={(e) => updateBlockSetting(editingBlockId, 'charactersToRemove', e.target.value)} />
                            </label>
                            <label className=" flex items-center gap-2 px-2 w-full md:w-3/4">
                                <p className="w-full mx-auto">Characters to split on:</p>
                                <input type="text" className="input input-bordered" value={selectedBlocks.get(editingBlockId)?.settings?.characterToSplit || ''} onChange={(e) => updateBlockSetting(editingBlockId, 'characterToSplit', e.target.value)} />
                            </label>
                            <label className="flex items-center gap-2 px-2 w-full md:w-3/4">
                                <p className="w-full mx-auto tooltip text-left" data-tip="Index of word to keep after splitting">Keep split item:</p>
                                <input type="number" className="input input-bordered" value={selectedBlocks.get(editingBlockId)?.settings?.keepSplitItem} min={0} onChange={(e) => updateBlockSetting(editingBlockId, 'keepSplitItem', parseInt(e.target.value, 10))}/>
                            </label>
                            {/* <select className="select select-bordered w-full" value={selectedBlocks.get(editingBlockId)?.settings?.interpretAs} onChange={(e) => updateBlockSetting(editingBlockId, 'interpretAs', e.target.value)}>
                                <option disabled defaultValue>Interpret as: </option>
                                <option>Text</option>
                                <option>Integer</option>
                                <option>Positive Integer</option>
                                <option>Negative Integer</option>
                                <option>Decimal</option>
                                <option>Positive Decimal</option>
                                <option>Negative Decimal</option>
                                <option>Percent</option>
                            </select> */}
                        </div>
                    </td>
                </tr>
            )}

            </>
          );
        }) : (
          <tr key={1} className="border-b border-gray-200 ">
            <td className="py-2 px-2 text-center text-lg whitespace-nowrap" colSpan="4">
              Select a block to get started
            </td>
          </tr>
        )}

            </tbody>
          </table>
        </div>
        </div>

        {true && (
          <div className=" w-full border-2 rounded-lg drop-shadow-lg">
            <p className="text-xl text-center font-bold">Results to Export</p>
            <div className="max-h-[50vh] overflow-scroll">
              <table className="w-full table">
                <thead className="sticky top-0 bg-base-300">
                  {selectedBlocks.size > 0 && 
                    <tr className="">
                    <th className="text-center">Frame</th>
                    <th className='text-center italic'>Time <br/>(from media timestamp)</th>
                    {Array.from(selectedBlocks.entries()).sort((a, b) => {
                      const [, blockDataA] = a;
                      const [, blockDataB] = b;
                      return blockDataA.uniqueID - blockDataB.uniqueID;
                    }).map(([blockId, blockData], index) => (
                      <th className="text-center" key={index}>{blockData?.settings?.seriesName ? blockData?.settings?.seriesName : `Block ${blockId}`}</th>
                    ))}
                  </tr>}
                </thead>
                <tbody >
                  {selectedBlocks.size > 0 && (
                    Array.from({ length: trackedBlocks.length }, (_, frameIndex) => ( // Create an array of length equal to the number of frames
                      <tr className="text-center" key={frameIndex}>
                        <td className="text-center">
                          <button
                              className="btn btn-sm"
                              title={`Go to frame ${frameIndex + 1}`}
                              onClick={() => handleFrameClick(frameIndex)}
                          >
                              {frameIndex + 1}
                          </button>
                        </td>
                        <td>{formatSeconds(Number(imageURL[frameIndex].split('/').pop().split('.')[0])/1000, "min:sec") || "0:00"}</td>
                          {Array.from(selectedBlocks.entries()).sort((a, b) => {
                            const [, blockDataA] = a;
                            const [, blockDataB] = b;
                            return blockDataA.uniqueID - blockDataB.uniqueID;
                          }).map(([blockId, blockData], index) => {
                            const seriesFrames = selectedSeries.get(blockId); 
                            const block = seriesFrames ? seriesFrames[frameIndex] : null; 
                            const modifiedText = block ? applyBlockSettings(block.text, blockData.settings) : "-";
                            const originalText = block?.originalText
                            return <td key={index}>{modifiedText} {originalText ? ` (${originalText})` : ""}</td>;
                            
                        })}
                      </tr>
                    ))
                  )}
                  {selectedBlocks.size === 0 && (
                    <tr className="border-b border-gray-200 ">
                      <td className="py-2 px-6 text-center whitespace-nowrap text-lg font-normal" colSpan="2">
                        Select a block to get started
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {selectedBlocks && selectedBlocks.size > 0 && (
          <div className="flex flex-row gap-4 items-center justify-center mx-auto pt-4">
              {/* <button className="btn btn-disabled">Export to Google Sheets</button> */}
              <button className="btn btn-success" onClick={exportToCSV}>Export as csv</button>
            </div>
        )}
      </div>
    </div>
  );
}

export default ViewNumericalUpload;
